// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import cartLineSharedStyles from "@sc/App/SharedStyles/CartLineSharedStyles";
import { requisitionsProductListLineStyles } from "@sc/Overrides/Widgets/Requisitions/RequisitionsProductListLine";
import { css } from "styled-components";

requisitionsProductListLineStyles.productDescriptionStyles = {
    ...cartLineSharedStyles.productDescription,
};
requisitionsProductListLineStyles.productImageStyles = {
    ...cartLineSharedStyles.productImage,
};
requisitionsProductListLineStyles.productPriceStyles = {
    ...cartLineSharedStyles.productPrice,
};
requisitionsProductListLineStyles.subtotalHeadingAndText = {
    ...cartLineSharedStyles.extendedUnitNetPriceText?.extendedStyles,
};
requisitionsProductListLineStyles.noPrice = {
    ...cartLineSharedStyles.extendedUnitNetPriceText,
    extendedStyles: {
        ...cartLineSharedStyles.extendedUnitNetPriceText?.extendedStyles,
        text: {
            ...cartLineSharedStyles.extendedUnitNetPriceText?.extendedStyles?.text,
            color: "primary.main",
        },
    },
};
requisitionsProductListLineStyles.productPartNumbersStyles = {
    ...cartLineSharedStyles.productPartNumbers,
};

requisitionsProductListLineStyles.requisitionLinesAccordion = {
    mergeCss: true,
    css: css`
        margin-top: 10px;
    `,
};

requisitionsProductListLineStyles.GridContainer = {
    notes: {
        css: css`
            grid-column: 2 / 8;
        `,
    },
};

requisitionsProductListLineStyles.selectedCheckbox = {
    css: css`
        margin-right: 10px;
        width: fit-content;
    `,
};
